// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"d73affc08033c5360b88","883":"0294f2d8d3e7fbabca83"}[chunkId] + ".js";
};